<div class="wg-grid-overlay">
  @for (row of gridRows; track row) {
    <div
      class="wg-preview-item wg-preview-row"
      [style.height]="row.height"
    [style.top]="row.y"></div>
  }
  @for (column of gridCols; track column) {
    <div
      class="wg-preview-item wg-preview-column"
      [style.width]="column.width"
    [style.left]="column.x"></div>
  }
  @if (activeHighlight) {
    <div
      class="wg-preview-item wg-preview-highlight"
      [style.background-color]="highlightColor"
      [style.top]="activeHighlight.y"
      [style.height]="activeHighlight.height"
      [style.left]="activeHighlight.x"
    [style.width]="activeHighlight.width"></div>
  }
</div>
